import React from 'react';

import MergeTypeIcon from '@mui/icons-material/MergeType';
import BaseButton, { IBaseButtonProps } from './_module/BaseButton';

interface IProps extends IBaseButtonProps {
  text?: string;
}

export default function ButtonMerge(props: IProps) {
  const { color, variant, onClick, text, size, disabled, fullWidth } = props;

  return (
    <BaseButton
      color={color}
      variant={variant}
      fullWidth={fullWidth}
      disabled={disabled}
      onClick={onClick}
      size={size}
      startIcon={
        <MergeTypeIcon fontSize={size === 'small' ? 'small' : undefined} />
      }
    >
      {text}
    </BaseButton>
  );
}
